{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "حدد عنصرًا",
  "tableResizer": "أداة تغيير الحجم",
  "expand": "Expand",
  "collapse": "Collapse"
}
